var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21276_99439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21276_99439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77785 13.3334C1.47229 13.3334 1.21072 13.2246 0.993131 13.007C0.775542 12.7894 0.666748 12.5278 0.666748 12.2223V4.66669H1.77785V12.2223H13.3334V13.3334H1.77785ZM4.00006 11.1111C3.69451 11.1111 3.43294 11.0023 3.21535 10.7848C2.99776 10.5672 2.88896 10.3056 2.88896 10V3.77779C2.88896 3.47223 2.99776 3.21066 3.21535 2.99307C3.43294 2.77548 3.69451 2.66669 4.00006 2.66669H14.2223C14.5279 2.66669 14.7894 2.77548 15.007 2.99307C15.2246 3.21066 15.3334 3.47223 15.3334 3.77779V10C15.3334 10.3056 15.2246 10.5672 15.007 10.7848C14.7894 11.0023 14.5279 11.1111 14.2223 11.1111H4.00006ZM5.55563 10C5.55563 9.5667 5.4047 9.19911 5.10285 8.89725C4.80099 8.5954 4.4334 8.44447 4.00006 8.44447V10H5.55563ZM12.6667 10H14.2223V8.44447C13.789 8.44447 13.4214 8.5954 13.1195 8.89725C12.8177 9.19911 12.6667 9.5667 12.6667 10ZM9.11118 8.88892C9.66674 8.88892 10.139 8.69448 10.5278 8.30559C10.9167 7.9167 11.1112 7.44448 11.1112 6.88892C11.1112 6.33336 10.9167 5.86114 10.5278 5.47225C10.139 5.08336 9.66674 4.88892 9.11118 4.88892C8.55563 4.88892 8.0834 5.08336 7.69451 5.47225C7.30563 5.86114 7.11118 6.33336 7.11118 6.88892C7.11118 7.44448 7.30563 7.9167 7.69451 8.30559C8.0834 8.69448 8.55563 8.88892 9.11118 8.88892ZM4.00006 5.33335C4.4334 5.33335 4.80099 5.18243 5.10285 4.88057C5.4047 4.57872 5.55563 4.21112 5.55563 3.77779H4.00006V5.33335ZM14.2223 5.33335V3.77779H12.6667C12.6667 4.21112 12.8177 4.57872 13.1195 4.88057C13.4214 5.18243 13.789 5.33335 14.2223 5.33335Z",
    fill: "#EEC11B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.eccb1036.svg";
export { ForwardRef as ReactComponent };